module.exports = __webpack_public_path__ + "static/img/QQ图片20200821144435.07a2a293.jpg";